<template>
  <section class="hot-map">
    <HeaderBar :is-prev="true" :my-title='myHeader' ></HeaderBar>
    <p>按照以下表格选择您相应的问题按键。</p>
    <p>（电话服务时间：7*24小时全年无休）</p>
    <p>拨打统一热线后，根据语音提示，选
       择相应数字。</p>
    <img class="hot-map-img" :src="require('../assets/hot-map.png')" alt="">
 
  </section>
  
  

</template>

<script>
 import HeaderBar from './base/header'
export default {
 
  components: {
    HeaderBar
  },
   
  name: 'hotMap',
  created: function () {
    
  },
  data () {
    return {
      myHeader:"热线地图"
    }
  },
  methods:{
    
  }
}
</script>


<style scoped>
.hot-map p{width: 5.6rem;font-size: 0.32rem;line-height: 0.5rem;margin-left: 1rem;}
.hot-map p:nth-of-type(1){margin-top: 0.6rem}
.hot-map-img{width: 5.73rem;height: 8.05rem;margin: 0.52rem 0 0 0.9rem}
.hot-map{height: 100%;width: 100%;background: #fafafa}
</style>



// WEBPACK FOOTER //
// src/components/hotMap.vue